import React, { useState } from 'react'
import { SEOComponent } from 'src/consumer/helpers/utilFunctions'
import PublicAppHeader from '../PublicAppHeader'
import { ClubbedAuthModal } from '../SignIn/ClubbedAuthComponents'
import { AppDownloadComponent } from '../ListingPageComponentsAndHelpers/ListingPageComponents'
import { PublicAppFooter } from '../PublicAppFooter'
import { APP_CONSTANTS } from 'src/consumer/constants'

export default function DownloadAppPage() {
  const [showClubbedAuthModal, setShowClubbedAuthModal] = useState(false)
  const [typeOfClubbedAuthModal, setTypeOfClubbedAuthModal] = useState('login')

  return (
    <>
      <SEOComponent
        title={'Download the AUMHUM App | AUMHUM'}
        description={`Unlock Inner Peace: Download the Aumhum App Now! Embrace mindfulness and meditation in just a few taps.`}
        keywordsArr={['download', 'app', 'aumhum']}
        image={APP_CONSTANTS.APP_LOGO_LINK}
      />
      <PublicAppHeader
        config={{ showLinks: true }}
        loginFunction={() => {
          setTypeOfClubbedAuthModal('login')
          setShowClubbedAuthModal(true)
        }}
        registerFunction={() => {
          setTypeOfClubbedAuthModal('signup')
          setShowClubbedAuthModal(true)
        }}
      />
      <ClubbedAuthModal
        open={showClubbedAuthModal}
        onClose={() => setShowClubbedAuthModal(false)}
        loginVariant={typeOfClubbedAuthModal === 'login'}
      />
      <AppDownloadComponent />
      <PublicAppFooter />
    </>
  )
}
